<template>
  <div class="page">
    <p>
      This is a work in progress; you still can leave comments on <a href="https://experimentslabs.com/projects/garden-party">the project page</a>.
    </p>

    <p>Feel free to break things, there is no database behind this (a page refresh and it's all new).</p>
  </div>
</template>
<script>
export default {
  name: 'Home',
}
</script>
